import React from 'react';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null
    };
  }



  componentDidCatch(error, info) {
    console.log(info)
    this.setState({
      hasError: true,
      error: error
    });
    Sentry.withScope(scope => {
      Object.keys(info).forEach(key => {
        scope.setExtra(key, info[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <h1 className="error-page__title">خطا در سیستم!</h1>
          <div className="error-page__footer">
            <p className="error-page__paragraph">با ارسال توضیح کوتاه درباره چگونگی مشاهده این صفحه در سیستم به ما در جهت رفع مشکل میتوانید کمک کنید.</p>
            <button className="error-page__button btn btn--lg btn--primary" onClick={
                ()=>{
                    Sentry.showReportDialog()
                }
                // () => Sentry.showReportDialog()
            }>گزارش خطا</button>
          </div>
        </div>
      );
     }
     return this.props.children;
  }
}

export default ErrorBoundary;
